import * as React from "react";
const IconBrochure = (props) => (
  <svg
    width={23}
    height={20}
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 15V5C18 3.11438 18 2.17157 17.4142 1.58579C16.8284 1 15.8856 1 14 1H9C7.11438 1 6.17157 1 5.58579 1.58579C5 2.17157 5 3.11438 5 5V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H14C15.8856 19 16.8284 19 17.4142 18.4142C18 17.8284 18 16.8856 18 15Z"
      stroke="#1C1C2C"
      strokeWidth={1.3}
    />
    <path
      d="M18 4H18.5C19.9142 4 20.6213 4 21.0607 4.43934C21.5 4.87868 21.5 5.58579 21.5 7V14C21.5 15.4142 21.5 16.1213 21.0607 16.5607C20.6213 17 19.9142 17 18.5 17H18"
      stroke="#1C1C2C"
      strokeWidth={1.3}
      strokeLinecap="round"
    />
    <path
      d="M5 4H4.5C3.08579 4 2.37868 4 1.93934 4.43934C1.5 4.87868 1.5 5.58579 1.5 7V14C1.5 15.4142 1.5 16.1213 1.93934 16.5607C2.37868 17 3.08579 17 4.5 17H5"
      stroke="#1C1C2C"
      strokeWidth={1.3}
      strokeLinecap="round"
    />
    <path
      d="M14 6L9 6M14 10L9 10M14 14H9"
      stroke="#1C1C2C"
      strokeWidth={1.3}
      strokeLinecap="round"
    />
  </svg>
);
export default IconBrochure;
